export default __webpack_public_path__ + "static/media/bisaleghat.7f3dc65f.jpg";